// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div._2M97P{position:relative}div._2M97P ._3EB08{display:flex;flex-flow:column}div._2M97P ._3EB08 ._3BQM5{margin-bottom:16px}div._2M97P ._3EB08._37vBv{display:none}div._2M97P ._262eQ{margin-bottom:16px}div._2M97P._1VsFp{background:#fff;padding:16px 0px 16px 16px;display:flex;flex-flow:column;height:calc(100vh - 58px)}div._2M97P._1VsFp ._3h56N{overflow-y:scroll;padding-right:16px}div._2M97P.uxx8u ._3EB08{flex-flow:row;justify-content:space-between;align-items:center;margin-bottom:0}div._2M97P.uxx8u._1VsFp{flex-flow:column;height:calc(100vh)}div._2M97P.uxx8u._1VsFp ._3EB08{flex-flow:column;align-items:flex-start}div._2M97P.uxx8u._1VsFp ._3h56N{overflow-y:scroll;overflow-x:hidden}div._2M97P.uxx8u._1VsFp ._3BQM5{margin-bottom:12px}.aff_loading.aff_loader_expandend::after{left:-20px;right:-20px}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_2M97P",
	"header": "_3EB08",
	"tabs": "_3BQM5",
	"hide": "_37vBv",
	"search_container": "_262eQ",
	"in_overlay": "_1VsFp",
	"scroll": "_3h56N",
	"web": "uxx8u"
};
export default ___CSS_LOADER_EXPORT___;
